import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore, type User } from '@/stores';
import { LoadingState } from '@/components/ui';
import { useSessionCheck } from './useSessionCheck';

/**
 * Where a signed-in user lands by default: admins in the admin area,
 * everyone else (USER, CUSTOMER_ADMIN) on the design overview.
 */
export function homePathForRole(role: User['role'] | undefined): string {
  return role === 'ADMIN' ? '/admin' : '/designs';
}

/**
 * Role dispatch for `/`: verifies the session once, then forwards to the
 * login page or the role's home. Renders only the loader meanwhile, so the
 * wordmark, the publish return and the fallback route all share one target.
 */
export function RoleDispatch() {
  const { t } = useTranslation();
  const { user, isAuthenticated } = useAuthStore();
  const isChecking = useSessionCheck();

  if (isChecking) {
    return <LoadingState fullscreen label={t('common.loading')} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={homePathForRole(user?.role)} replace />;
}
